<div class="cm-tree-filler" (click)="onClick($event)" (dragover)="dragOver($event)" (dragleave)="dragLeave($event)" (drop)="drag.drop($event)">
    @if ($isEmpty()) {
        <div class="cm-empty-tree">Drag nodes here</div>
    }
</div>
